function separateGeoJsonLayers(geoJson, geoJsonLayers, shapeLayerKey) {
  let geoJsonToEdit = _.cloneDeep(geoJson);
  if (geoJsonToEdit.features.length === 0) {
    return geoJsonLayers;
  }else{
    let currentObject = geoJsonToEdit.features[0];
    let currentLayerToRemoveKey = currentObject.properties[shapeLayerKey];
    geoJsonLayers[currentLayerToRemoveKey] = [];
    for (var i = geoJsonToEdit.features.length - 1; i >= 0; i--) {
      if (geoJsonToEdit.features[i].properties[shapeLayerKey] === currentLayerToRemoveKey) {
          geoJsonLayers[currentLayerToRemoveKey].push(geoJsonToEdit.features[i]);
          geoJsonToEdit.features.splice(i, 1);
      }
    }
    return separateGeoJsonLayers(geoJsonToEdit, geoJsonLayers, shapeLayerKey)
  }
}

function validateEmail(emailCandidate){
  let emailValidationRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailValidationRegex.test(emailCandidate);
}
export {
  separateGeoJsonLayers,
  validateEmail
}



// WEBPACK FOOTER //
// ./src/utils.js